import { render, staticRenderFns } from "./CardNotes.vue?vue&type=template&id=9a6e139c&"
import script from "./CardNotes.vue?vue&type=script&lang=ts&"
export * from "./CardNotes.vue?vue&type=script&lang=ts&"
import style0 from "./CardNotes.vue?vue&type=style&index=0&id=9a6e139c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports